import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Default cap for text-like fields. Individual inputs can provide a smaller
 * (or deliberately different) `maxLength` when their domain requires it.
 */
export const DEFAULT_INPUT_MAX_LENGTH = 500;

const inputTypesWithoutTextLength = new Set([
  "button",
  "checkbox",
  "color",
  "date",
  "datetime-local",
  "file",
  "hidden",
  "image",
  "month",
  "number",
  "radio",
  "range",
  "reset",
  "submit",
  "time",
  "week",
]);

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, maxLength, ...props }, ref) => {
    const resolvedMaxLength =
      maxLength ?? (inputTypesWithoutTextLength.has(type ?? "text") ? undefined : DEFAULT_INPUT_MAX_LENGTH);

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
        maxLength={resolvedMaxLength}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
